'use strict';

import React from 'react';

const OfflineBanner = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="offline-banner">
      You're offline — changes will be saved locally and synced when you reconnect.
    </div>
  );
};

export default OfflineBanner;



// WEBPACK FOOTER //
// ./src/components/utilities/OfflineBanner.jsx